__turbopack_context__.v({
  "fullWidth": "Input-module-scss-module__q9kTnq__fullWidth",
  "input": "Input-module-scss-module__q9kTnq__input",
});
